import { INameChangeViewModel } from '../types/nameChangeViewModel'

export class NameChangeViewModel implements INameChangeViewModel
{
    leaseNumber: string = ''
    make: string = ''
    oemId: number = 0
    customerAccountType: number = 0  
    isActiveLease: boolean = false
    hasExistingNameChangeRequest: boolean = false
    existingNameChangeRequestId: string = ''
    referenceNumber: string = ''
}